import { useEffect } from "react";
import Adminlayout from "../Adminlayout";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";
import AlertNotification from "./AlertNotification";
import StudentDetails from "../../components/studentPortal/Components/StudentDetails";

const MyApplicationsForm2 = () => {
  const dispatch = useDispatch();
  const student = useSelector((state) => state.auth.studentData);
  
  useEffect(() => {
    authService.getUser(dispatch);
  }, []);


  return (
    <Adminlayout>
      <AlertNotification />
          
              <StudentDetails
                student={student}
       
              />
        
    </Adminlayout>
  );
};

export default MyApplicationsForm2;